<template>
  <div class="menu-06" id="Menu06">
    <v-card
      elevation="0"
      class="card card-mobile"
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label class="ml-5 mr-15 my-5" style="color: #444444; font-size: 20px">
          {{ $t("Log") }}
        </label>
      </v-system-bar>
      <!-- ******** header, add new -->
      <v-layout row class="mx-8 mt-10">
        <v-flex xs12 sm4 md4 lg2>
          <v-btn block color="#A6CC39" dark class="text-capitalize">{{
            $t("Log")
          }}</v-btn>
        </v-flex>
      </v-layout>

      <v-layout align-center class="mx-8">
        <v-flex shrink my-5 class="switch-btn">
          <v-btn
            block
            class="text"
            depressed
            tile
            outlined
            @click="onClickRunning"
            :style="{
              'border-radius': '5px 0 0 5px',
              height: '40px',
              'text-transform': 'none',
              'background-color': running.backcolor,
              color: running.color,
              border: running.border
            }"
            >{{ $t("active") }}</v-btn
          >
        </v-flex>
        <v-flex shrink my-5 class="switch-btn">
          <v-btn
            block
            class="text"
            depressed
            tile
            @click="onClickRemoved"
            :style="{
              'border-radius': '0 5px 5px 0',
              height: '40px',
              'text-transform': 'none',
              'background-color': removed.backcolor,
              color: removed.color,
              border: removed.border
            }"
            >{{ $t("inactive") }}</v-btn
          >
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding:3px;margin-right:1%;margin-left:1%">
        <v-flex style="padding:12px">
          <v-text-field
            v-model="search"
            outlined
            dense
            autocomplete="off"
            color="#2f9a61"
            class="text"
            style="border-color: #d9d9d9; height: 40px;"
          >
            <v-icon slot="append" class="searchicon">mdi-magnify</v-icon>
          </v-text-field>
        </v-flex>

        <v-flex style="padding:12px">
          <div class="d-flex">
            <div class="mt-2">
              {{ $t("from") }}
            </div>
            <div class="ml-3" style="width:80%">
              <date-picker
                v-model="logDateFrom"
                :lang="langDatetime"
                format="DD/MM/YYYY"
                width="100%"
                :not-before="notBefore(logDateTo)"
                :not-after="logDateTo"
                @change="OnChangeSDate()"
                :disabled="disablepicker"
                :disabled-days="disableDate"
                placeholder="DD/MM/YYYY"
                :must-sort="true"
                class="dp2 dp"
              >
              </date-picker>
            </div>
          </div>
        </v-flex>

        <v-flex style="padding:12px">
          <div class="d-flex">
            <div class="mt-2">
              {{ $t("to") }}
            </div>
            <div class="ml-8" style="width:80%">
              <date-picker
                v-model="logDateTo"
                :lang="langDatetime"
                format="DD/MM/YYYY"
                width="100%"
                :not-before="logDateFrom"
                :not-after="notAfter(logDateFrom)"
                @change="OnChangeDate('to')"
                :disabled="disablepicker"
                :disabled-days="disableDate"
                placeholder="DD/MM/YYYY"
                class="dp2 dp"
              >
              </date-picker>
            </div>
          </div>
        </v-flex>

        <v-flex style="padding:12px">
          <v-autocomplete
            v-model="customDDL"
            :items="selectDDL"
            item-text="text"
            item-value="value"
            color="#2f9a61"
            style="border-color: #707070"
            placeholder="Custom"
            autocomplete="off"
            clearable
            outlined
            dense
            @change="onChangecustomDDL(customDDL)"
          >
            <v-icon
              slot="append"
              class="v-icon notranslate mdi mdi-chevron-down theme--light"
            />
          </v-autocomplete>
        </v-flex>

        <v-flex style="padding:12px">
          <v-btn
            block
            @click.stop="export_dialog = true"
            style="
              background-color: #6cc8a0;
              color: #fff;
              font-family: Dbx;
              font-size: 18px;
              text-transform: none;
              height: 40px;
            "
          >
            {{ $t("exportexcel") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- ******** datatable -->
      <v-data-table
        style="display: flex"
        :mobile-breakpoint="NaN"
        :headers="headers"
        :items="logdata"
        sort-by="createDate"
        sort-desc="true"
        hide-default-footer
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :search="search"
        :must-sort="true"
        class="usertable p-horizontal my-5 mx-7 for-log"
      >
        <template v-slot:item="{ item }">
          <tr @click="al(item)" style="cursor: pointer">
            <td>
              <v-layout row="wrap" align-center style="padding-left: 15px">
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 190px"
                >
                  {{ DateFormat(item.createDate) }}
                  {{ TimeFormat(item.createDate) }}
                </v-flex>
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 370px"
                  >{{ item.logId }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 210px"
                  >{{ item.applicationName }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 370px"
                  >{{ item.userId }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 110px"
                  >{{ item.userName }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 370px"
                  >{{ item.companyID }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 110px"
                  >{{ item.correctionID }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 110px"
                  >{{ item.ip }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 110px"
                  >{{ item.phoneModel }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 270px"
                  >{{ item.description }}</v-flex
                >
              </v-layout>
            </td>
            <td style="text-align: center" class="table-text">
              {{ item.logType }}
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 110px"
                  >{{ item.methodName }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 110px"
                  >{{ item.exception }}</v-flex
                >
              </v-layout>
            </td>
            <td>
              <v-layout row="wrap" align-center>
                <v-flex
                  v-line-clamp:20="2"
                  class="table-text"
                  shrink
                  style="width: 220px"
                  >{{ item.logTrace }}</v-flex
                >
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- datatable ******** -->

      <!-- ******** pagination, perpage -->
      <v-layout
        row="wrap"
        align-center
        class="mt-5"
        style="margin-right: -35px;"
      >
        <v-spacer />
        <v-flex my-3 mr-5 style="min-width: 240px; max-width: 315px">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
            color="#E8E9EC"
          ></v-pagination>
        </v-flex>

        <v-flex shrink my-3 style="min-width: 173px">
          <select
            style="border:1px solid;
            border-color:#D9D9D9;border-radius:5pt;
            padding:5px;opacity:0.5
            background-color: #FFFFFF;width:110px;
            color:#4D4F5C;box-shadow: 0px 3px 6px #00000029;height:36px;"
            class="perPageText"
            v-model="itemsPerPage"
          >
            <option value="5">5 of {{ totalCount }}</option>
            <option value="10">10 of {{ totalCount }}</option>
            <option value="15">15 of {{ totalCount }}</option>
            <option value="20">20 of {{ totalCount }}</option>
            <option value="25">25 of {{ totalCount }}</option>
          </select>
          <span>
            <v-icon style="margin: 0.5rem 0 0 -2rem; vertical-align: top"
              >mdi-chevron-down</v-icon
            >
          </span>
        </v-flex>
      </v-layout>
      <!-- pagination, perpage ******** -->
    </v-card>

    <!-- Export Dialog -->
    <v-dialog
      content-class="export-dialog"
      v-model="export_dialog"
      max-width="490"
    >
      <v-card style="border-radius: 25px">
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex px-3 shrink class="title-text">{{ $t("export") }}</v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-4 mx-5>
          <v-flex md12 px-3 class="text">{{ $t("filetype") }}</v-flex>
          <v-flex md12 px-3>
            <v-text-field
              value="excel"
              :items="['excel']"
              class="text"
              outlined
              dense
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center mx-5>
          <v-flex md6 pt-4>
            <v-flex md12 px-3 class="text">
              {{ $t("startdate") }}
              <span style="color: red">*</span>
            </v-flex>
            <v-flex md12 px-3>
              <date-picker
                v-model="startDate"
                :lang="langDatetime"
                :not-before="notBefore(endDate)"
                :not-after="endDate"
                format="DD/MM/YYYY"
                width="100%"
                :disabled-days="disableDate"
                class="dp"
              >
                <template slot="calendar-icon">
                  <img
                    alt
                    src="@/assets/imgs/calendar.jpg"
                    style="width: 20px; height: 20px"
                  />
                </template>
              </date-picker>
            </v-flex>
          </v-flex>
          <v-flex md6 pt-4>
            <v-flex md12 px-3 class="text">
              {{ $t("enddate") }}
              <span style="color: red">*</span>
            </v-flex>
            <v-flex md12 px-3>
              <date-picker
                v-model="endDate"
                :lang="langDatetime"
                :not-before="startDate"
                :not-after="notAfter(startDate)"
                format="DD/MM/YYYY"
                width="100%"
                :disabled-days="disableDate"
                class="dp"
              >
                <template slot="calendar-icon">
                  <img
                    alt
                    src="@/assets/imgs/calendar.jpg"
                    style="width: 20px; height: 20px"
                  />
                </template>
              </date-picker>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center py-5 mx-5>
          <v-flex md6 pl-1 pr-4>
            <v-btn
              block
              class="ma-2"
              @click="
                (export_dialog = false), (startDate = null), (endDate = null)
              "
              text
              color="#707070;"
              style="color: #707070; text-transform: none"
              >{{ $t("cancel") }}</v-btn
            >
          </v-flex>
          <v-flex md6 pl-3 pr-3>
            <v-btn
              block
              depressed
              @click="onClickExport()"
              color="#6CC8A0"
              style="color: white; text-transform: none"
              >{{ $t("export") }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Preview Dialog -->
    <v-dialog v-model="preview_dialog" max-width="690">
      <v-card>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("date") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ DateFormat(preview_item.createDate) }}
            {{ TimeFormat(preview_item.createDate) }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("logid") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.logId }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("application") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.applicationName }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("userid") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.userId }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("username") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.userName }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("companyid") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.companyID }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">
            {{ $t("correlationid") }}
          </v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.correctionID }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("ip") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.ip }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("phonemodel") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.phoneModel }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("description") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.description }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("logtype") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.logType }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("methodname") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.methodName }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center pt-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("exception") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.exception }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center py-5 mx-5>
          <v-flex md12 px-3 class="title-text">{{ $t("logtrace") }}</v-flex>
          <v-flex xs12 px-3 shrink class="def-text">
            {{ preview_item.logTrace }}
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Search Dialog -->
    <v-dialog v-model="searchdialog" persistent max-width="950">
      <v-card class="pt-4">
        <v-card-title class="headline" style="margin-bottom: -0.3rem">
          <v-col>
            <label style="margin-bottom: 0px">{{ $t("searchlogs") }}</label>
          </v-col>
          <v-icon
            style="font-size: 28px; color: #43425d; margin-right: 0.5rem"
            @click="cancel"
            class="close"
            >mdi-window-close</v-icon
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex d-block lg6>
                <v-layout>
                  <label class="labeltext">{{ $t("date") }}</label>
                </v-layout>
                <v-layout style="margin-right: 0.5rem">
                  <date-picker
                    v-model="date"
                    :lang="langDatetime"
                    class="CalendarSearch"
                    :placeholder="localeDate()"
                    format="DD/MM/YYYY"
                  >
                    <template slot="calendar-icon">
                      <i class="fa fa-calendar-alt"></i>
                    </template>
                  </date-picker>
                </v-layout>
              </v-flex>
              <v-flex lg6>
                <label class="labeltext">{{ $t("logid") }}</label>
                <v-text-field
                  single-line
                  solo
                  dense
                  class="searchfield"
                  v-model="logId"
                  full-width
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex lg6 style="margin-right: 0.5rem">
                <label class="labeltext">{{ $t("username") }}</label>
                <v-text-field
                  single-line
                  solo
                  dense
                  class="searchfield"
                  v-model="userName"
                  full-width
                ></v-text-field>
              </v-flex>
              <v-flex lg6>
                <label class="labeltext">{{ $t("ip") }}</label>
                <v-text-field
                  single-line
                  solo
                  dense
                  class="searchfield"
                  v-model="ipAddress"
                  full-width
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex lg6 style="margin-right: 0.5rem">
                <label class="labeltext">{{ $t("phonemodel") }}</label>
                <v-text-field
                  single-line
                  solo
                  dense
                  class="searchfield"
                  v-model="phoneModel"
                  full-width
                ></v-text-field>
              </v-flex>
              <v-flex lg6>
                <label class="labeltext">{{ $t("description") }}</label>
                <v-text-field
                  single-line
                  solo
                  dense
                  class="searchfield"
                  v-model="description"
                  full-width
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex lg6 style="margin-right: 0.5rem">
                <label class="labeltext">{{ $t("logtype") }}</label>
                <v-text-field
                  single-line
                  solo
                  dense
                  class="searchfield"
                  v-model="logtype"
                  full-width
                ></v-text-field>
              </v-flex>
              <v-flex lg6>
                <label class="labeltext">{{ $t("methodname") }}</label>
                <v-text-field
                  single-line
                  solo
                  dense
                  class="searchfield"
                  v-model="methodName"
                  full-width
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex lg6 style="margin-right: 0.5rem">
                <label class="labeltext">{{ $t("exception") }}</label>
                <v-text-field
                  single-line
                  solo
                  dense
                  class="searchfield"
                  v-model="exception"
                  full-width
                ></v-text-field>
              </v-flex>
              <v-flex lg6>
                <label class="labeltext">{{ $t("logtrace") }}</label>
                <v-text-field
                  single-line
                  solo
                  dense
                  class="searchfield"
                  v-model="logTrace"
                  full-width
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions
          style="margin-right: 2rem; padding-bottom: 2rem; margin-top: -1rem"
        >
          <v-spacer></v-spacer>
          <v-btn
            depressed
            outlined
            style="border: none"
            class="searchText"
            @click="cancel"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="searchText"
            color="#284622"
            style="color: #fff"
            @click="searchMultiField()"
            >{{ $t("search") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Confirm -->
    <v-dialog v-model="confirmDialog" persistent max-width="490">
      <v-card class="confirm">
        <v-card-text
          class="title-text"
          style="color: #707070 !important; padding-left: 0px"
          >{{ $t("taketime") }}</v-card-text
        >
        <v-card-actions>
          <v-layout row="wrap">
            <v-btn
              class="ma-2 btnCancel"
              color="#707070"
              @click="confirmRange('n')"
              >{{ $t("cancel") }}</v-btn
            >
            <v-btn
              class="ma-2 btnConfirm"
              color="#707070"
              @click="confirmRange('y')"
              >{{ $t("ok") }}</v-btn
            ></v-layout
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Export Confirm -->
    <v-dialog v-model="confirmExportDialog" persistent max-width="490">
      <v-card class="confirm">
        <v-card-text
          class="title-text"
          style="color: #707070 !important; padding-left: 0px"
          >{{ $t("taketime") }}</v-card-text
        >
        <v-card-actions>
          <v-layout row="wrap">
            <v-btn
              class="ma-2 btnCancel"
              color="#707070"
              @click="
                (confirmExportDialog = false),
                  (export_dialog = false),
                  (startDate = null),
                  (endDate = null)
              "
              >{{ $t("cancel") }}</v-btn
            >
            <v-btn class="ma-2 btnConfirm" color="#707070" @click="Export()">{{
              $t("ok")
            }}</v-btn></v-layout
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GlobalMixin from "../Mixins/GlobalMixin";
import axios from "axios";
import enurl from "@/api/environment";
import store from "@/store";
import DatePicker from "vue2-datepicker";
import XLSX from "xlsx";
import "vue2-datepicker/index.css";
export default {
  name: "Menu06",
  components: {
    DatePicker
  },
  mixins: [GlobalMixin],
  props: {},
  data() {
    return {
      confirmDialog: false,
      confirmExportDialog: false,
      confirm: false,
      current: "running",
      preview_dialog: false,
      disablepicker: false,
      preview_item: {
        logId: "",
        disablepicker: false,
        userName: "",
        userId: "",
        ip: "",
        phoneModel: "",
        description: "",
        logType: "",
        method: "",
        exception: "",
        logTrace: "",
        createDate: "",
        correctionID: "",
        companyID: "",
        companyStatus: "",
        applicationName: ""
      },
      maHtet: "30px !important",
      startDate: null,
      endDate: null,
      export_dialog: false,
      logDateFrom: new Date(),
      logDateTo: new Date(),
      companyName: null,
      logList: [],
      url: enurl.apiUrl,
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      totalCount: 0,
      companyID: store.getters.companyid,
      password: null,
      characters: "a-z,A-Z,0-9",
      size: 10,
      tempID: null,
      search: "",
      employeeID: null,
      empID: null,
      employeeName: null,
      email: null,
      positionID: null,
      roleID: null,
      userID: null,
      isModalAddVisible: false,
      isModalEditVisible: false,
      isModalDeleteVisible: false,
      dialog: false,
      userId: store.getters.userid,

      logdataAll: [],
      logdata: [],
      logdataTemp: [],
      searchdialog: false,
      date: null,
      logId: null,
      userName: null,
      phoneModel: null,
      description: null,
      logtype: 1,
      methodName: null,
      exception: null,
      logTrace: null,
      ipAddress: null,
      searchStatus: false,
      langDatetime: {
        start: "2019-11-06",
        days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        months: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        pickers: [
          "next 7 days",
          "next 30 days",
          "previous 7 days",
          "previous 30 days"
        ]
      },
      logtypeDDL: [
        {
          value: 1,
          text: "Critical"
        },
        {
          value: 2,
          text: "High"
        },
        {
          value: 3,
          text: "Medium"
        },
        {
          value: 4,
          text: "Low"
        },
        {
          value: 5,
          text: "Verbose"
        }
      ],
      customDDL: null,
      selectDDL: [
        {
          value: 1,
          text: "Today"
        },
        {
          value: 2,
          text: "Yesterday"
        },
        {
          value: 3,
          text: "This week (Sun-Today)"
        },
        {
          value: 4,
          text: "Last 7 days"
        },
        {
          value: 5,
          text: "Last week (Sun-Sat)"
        }
      ],
      removed: {
        color: "#4CAF50",
        backcolor: "#F0F0F7",
        border: "1px solid #6CC8A0"
      },
      running: {
        color: "#fff",
        backcolor: "#6CC8A0",
        border: "1px solid #6CC8A0"
      }
    };
  },
  mounted: function() {
    var self = this;
    self.GetAllCompany();
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("date"),
          value: "createDate",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("logid"),
          align: "left",
          value: "logId",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("application"),
          value: "applicationName",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("userid"),
          value: "userId",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("username"),
          value: "userName",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("companyid"),
          value: "companyID",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("correlationid"),
          value: "correctionID",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("ip"),
          value: "ip",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("phonemodel"),
          value: "phoneModel",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("description"),
          value: "description",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("logtype"),
          value: "logType",
          align: "center",
          sortable: true,
          width: "200px"
        },
        {
          text: this.$t("methodname"),
          value: "methodName",
          align: "left",
          sortable: true,
          width: "150px"
        },
        {
          text: this.$t("exception"),
          align: "left",
          sortable: false,
          width: "150px"
        },
        {
          text: this.$t("logtrace"),
          align: "left",
          sortable: false,
          width: "190px"
        }
      ];
    }
  },
  watch: {
    logtype() {
      this.GetAllCompany();
    }
  },
  methods: {
    notBefore(v) {
      if (v) {
        const val = new Date(v);
        let d = new Date(val.setDate(val.getDate() - 6));
        return d;
      }
    },
    notAfter(v) {
      if (v) {
        const val = new Date(v);
        let d = new Date(val.setDate(val.getDate() + 6));
        return d;
      }
    },
    al(v) {
      let self = this;
      self.preview_dialog = true;
      self.preview_item = v;
    },
    onclickExportDialog() {
      let self = this;
      self.startDate = self.logDateFrom;
      self.endDate = self.logDateTo;
    },
    DateFormat(value) {
      let output = "-";
      let temp = new Date(value + "Z");
      try {
        let day = temp
          .getDate()
          .toString()
          .padStart(2, 0);
        let month = (temp.getMonth() + 1).toString().padStart(2, 0);
        let year = temp.getFullYear();
        output = `${day}/${month}/${year}`;
        return output;
      } catch (err) {
        return output;
      }
    },
    TimeFormat(value) {
      let output = "-";
      let temp = new Date(value + "Z");
      try {
        let hours = temp.getHours();
        let minutes = temp.getMinutes();
        if (hours.toString().length == 1) output = `0${hours}:${minutes}`;
        if (minutes.toString().length == 1) output = `${hours}:0${minutes}`;
        if (hours.toString().length == 1 && minutes.toString().length == 1)
          output = `0${hours}:0${minutes}`;
        if (hours.toString().length != 1 && minutes.toString().length != 1)
          output = `${hours}:${minutes}`;
        return output;
      } catch (err) {
        return output;
      }
    },
    onClickExport() {
      let self = this;

      const oneDay = 24 * 60 * 60 * 1000;
      const diffDays = Math.round(
        Math.abs((self.startDate - self.endDate) / oneDay)
      );
      if (diffDays == 6) {
        self.confirmExportDialog = true;
      } else {
        self.Export();
      }
    },
    Export() {
      let self = this;
      const exportdata = self.logdataAll.filter(
        d =>
          new Date(d.createDate).setHours(0, 0, 0, 0) >=
            self.startDate.setHours(0, 0, 0, 0) &&
          new Date(d.createDate).setHours(0, 0, 0, 0) <=
            self.endDate.setHours(0, 0, 0, 0)
      );

      let wsdata = [];
      let wb = XLSX.utils.book_new();
      for (let j = 0; j < exportdata.length; j++) {
        wsdata.push({
          [this.$t("date")]:
            self.DateFormat(exportdata[j].createDate) +
            " " +
            self.TimeFormat(exportdata[j].createDate),
          [this.$t("logid")]: exportdata[j].logId,
          [this.$t("applicationName")]: exportdata[j].applicationName,
          [this.$t("UserID")]: exportdata[j].userId,
          [this.$t("username")]: exportdata[j].userName,
          [this.$t("CompanyID")]: exportdata[j].companyID,
          [this.$t("CorrelationID")]: exportdata[j].correctionID,
          [this.$t("ip")]: exportdata[j].ip,
          [this.$t("phonemodel")]: exportdata[j].phoneModel,
          [this.$t("description")]: exportdata[j].description,
          [this.$t("logtype")]: exportdata[j].logType,
          [this.$t("methodname")]: exportdata[j].methodName,
          [this.$t("exception")]: exportdata[j].exception,
          [this.$t("logtrace")]: exportdata[j].logTrace
        });
      }

      var ws = XLSX.utils.json_to_sheet(wsdata);
      var range = XLSX.utils.decode_range(ws["!ref"]);
      var noRows = range.e.r; //No of Rows
      ws["!cols"] = [
        { wch: 30 },
        { wch: 40 },
        { wch: 30 },
        { wch: 40 },
        { wch: 20 },
        { wch: 40 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 45 },
        { wch: 20 },
        { wch: 45 },
        { wch: 45 },
        { wch: 300 }
      ];
      let wsrows = [];
      for (let i = 0; i < noRows; i++) {
        wsrows.push({ hpt: 50 });
      }
      ws["!rows"] = wsrows;
      let tempsheetname = "All Log Record";
      XLSX.utils.book_append_sheet(wb, ws, tempsheetname);
      var date = new Date(self.startDate);
      var edate = new Date(self.endDate);
      let start = date.getDate();
      let end = edate.getDate();
      let month = (date.getMonth() + 101).toString().substring(1);
      let emonth = (edate.getMonth() + 101).toString().substring(1);
      let year = date.getFullYear();
      let todaydate = `${start}-${month}-${year}to${end}-${emonth}-${year}`;
      let exportExcelName = "";
      console.log(this.current);
      if (this.current == "running") {
        exportExcelName = `SeedLogActiveExport_${todaydate}.xlsx`;
      } else {
        exportExcelName = `SeedLogInactiveExport_${todaydate}.xlsx`;
      }

      XLSX.writeFile(wb, exportExcelName);
      this.confirmExportDialog = false;
      this.export_dialog = false;
      this.startDate = null;
      this.endDate = null;
    },
    onChangecustomDDL(value) {
      let self = this;
      self.logdataTemp = self.logdata;
      self.disablepicker = true;
      var today = new Date();
      self.logDateFrom = new Date();
      self.logDateTo = new Date();
      if (value != null) {
        switch (value) {
          case 1:
            break;

          case 2:
            self.logDateFrom.setDate(today.getDate() - 1);
            self.logDateTo.setDate(today.getDate() - 1);
            break;

          case 3:
            var temp = today.getDay();
            self.logDateFrom.setDate(today.getDate() - temp);
            break;

          case 4:
            self.logDateFrom.setDate(today.getDate() - 7);
            self.logDateTo.setDate(today.getDate() - 1);
            break;

          case 5:
            var temp1 = today.getDay() + 7;
            var temp2 = today.getDay() + 1;
            self.logDateFrom.setDate(today.getDate() - temp1);
            self.logDateTo.setDate(today.getDate() - temp2);
            break;

          case 6:
            self.logDateFrom.setDate(today.getDate() - 14);
            self.logDateTo.setDate(today.getDate() - 1);
            break;

          case 7:
            self.logDateFrom.setDate(1);
            break;

          case 8:
            self.logDateFrom.setDate(today.getDate() - 30);
            self.logDateTo.setDate(today.getDate() - 1);
            break;

          case 9:
            var temp3 = today.getMonth();
            self.logDateFrom.setMonth(temp3 - 1);
            self.logDateTo.setMonth(temp3 - 1);
            self.logDateFrom.setDate(1);
            if (temp3 == 1) {
              var year = today.getFullYear() % 4;
              if (year == 0) {
                self.logDateTo.setDate(28);
              } else {
                self.logDateTo.setDate(28);
              }
            } else if (temp3 == 3 || temp3 == 5 || temp3 == 8 || temp3 == 10) {
              self.logDateTo.setDate(30);
            } else {
              self.logDateTo.setDate(30);
            }
            break;

          case 10:
            self.logDateFrom = new Date();
            self.logDateTo = new Date();
            break;
          default:
            self.disablepicker = false;
        }
      } else {
        self.disablepicker = false;
        self.logDateFrom.setDate(today.getDate());
        self.logDateTo.setDate(today.getDate());
      }
      self.onChangelogtypeDDL();
    },
    onChangelogtypeDDL() {
      let self = this;

      self.OnChangeDate();
      self.filterByLogType();
    },
    filterByLogType() {
      let self = this;
      const logtype = self.logtype;
      if (logtype != null) {
        switch (logtype) {
          case 1:
            self.logdata = self.logdata.filter(d => d.logType == "Critical");
            break;
          case 2:
            self.logdata = self.logdata.filter(
              d => d.logType == "Critical" || d.logType == "High"
            );
            break;
          case 3:
            self.logdata = self.logdata.filter(
              d =>
                d.logType == "Critical" ||
                d.logType == "High" ||
                d.logType == "Medium"
            );
            break;
          case 4:
            self.logdata = self.logdata.filter(
              d =>
                d.logType == "Critical" ||
                d.logType == "High" ||
                d.logType == "Medium" ||
                d.logType == "Low"
            );
            break;
          case 5:
            self.logdata = self.logdata.filter(d =>
              d.logType == "Critical" ||
              d.logType == "High" ||
              d.logType == "Medium" ||
              d.logType == "Low"
                ? "Low"
                : "low" || d.logType == "Verbose"
            );
            break;
          default:
            break;
        }
      }
      self.totalCount = self.logdata.length;
    },
    OnChangeSDate() {
      let self = this;
      self.logDateTo = self.logDateFrom;
      self.onChangelogtypeDDL();
      self.OnChangeDate();
    },
    OnChangeDate(v) {
      let self = this;
      console.log(this.logDateTo);
      if (self.logDateTo) {
        if (v == "to") {
          const oneDay = 24 * 60 * 60 * 1000;
          const diffDays = Math.round(
            Math.abs((self.logDateFrom - self.logDateTo) / oneDay)
          );
          if (diffDays == 6) {
            self.confirmDialog = true;
          } else {
            self.confirmRange();
          }
        } else {
          self.confirmRange();
        }
      } else {
        self.logdata = [];
      }
    },
    confirmRange(v) {
      let self = this;
      if (v == "n") {
        self.logDateTo = self.logDateFrom;
      }
      if (self.logDateFrom != null && self.logDateTo != null) {
        self.logdata = self.logdataAll.filter(
          d =>
            new Date(d.createDate + "Z").setHours(0, 0, 0, 0) >=
              self.logDateFrom.setHours(0, 0, 0, 0) &&
            new Date(d.createDate + "Z").setHours(0, 0, 0, 0) <=
              self.logDateTo.setHours(0, 0, 0, 0)
        );
      } else {
        self.logdata = self.logdataAll;
      }
      self.totalCount = self.logdata.length;
      self.filterByLogType();
      self.confirmDialog = false;
    },
    resetFieldOnTab() {
      let self = this;
      self.logDateFrom = new Date();
      self.logDateTo = new Date();
      self.disablepicker = null;
      self.customDDL = null;
      self.logtype = 1;
      self.search = null;
      self.page = 1;
      self.GetAllCompany();
    },
    resetFieldOnTab1() {
      let self = this;
      self.logDateFrom = new Date();
      self.logDateTo = new Date();
      self.disablepicker = null;
      self.customDDL = null;
      self.logtype = 1;
      self.search = null;
      self.page = 1;
      self.GetAllCompany();
    },
    onClickRunning() {
      let self = this;
      self.current = "running";
      self.resetFieldOnTab();
      self.running = {
        color: "#fff",
        backcolor: "#6CC8A0",
        border: "1px solid #4CAF50"
      };
      self.removed = {
        color: "#4CAF50",
        backcolor: "#F0F0F7",
        border: "1px solid #4CAF50"
      };
      self.logdataAll = self.logdataTemp.filter(d => d.companyStatus == 1);
      self.logDateFrom = new Date();
      self.logDateTo = new Date();
      self.onChangelogtypeDDL();
    },
    onClickRemoved() {
      let self = this;
      self.current = "remove";
      self.resetFieldOnTab1();
      self.removed = {
        color: "#fff",
        backcolor: "#6CC8A0",
        border: "1px solid #4CAF50"
      };
      self.running = {
        color: "#4CAF50",
        backcolor: "#F0F0F7",
        border: "1px solid #4CAF50"
      };
      self.logdataAll = self.logdataTemp.filter(d => d.companyStatus != 1);
      self.logDateFrom = new Date();
      self.logDateTo = new Date();
      self.onChangelogtypeDDL();
    },
    cancel() {
      this.searchdialog = false;
      this.clearFileds();
    },
    localeDate() {
      return this.$t("selectdate");
    },
    dateFormat(date) {
      if (date != null) {
        date = date.split("T")[0];
        date = date.split("-");
        date = date[2] + "/" + date[1] + "/" + date[0];
        return date;
      } else {
        return "";
      }
    },
    clearSearch() {
      let self = this;
      self.GetAllCompany();
      self.searchStatus = false;
    },
    searchMultiField() {
      let self = this;
      let isoDate = null;

      if (self.date != null) {
        isoDate = new Date(
          self.date.getTime() - self.date.getTimezoneOffset() * 60000
        ).toISOString();
      }

      let temp = {
        logId: self.logId,
        date: isoDate,
        userName: self.userName,
        ip: self.ipAddress,
        phoneModel: self.phoneModel,
        description: self.description,
        logType: self.logType,
        methodName: self.methodName,
        exception: self.exception,
        logTrace: self.logTrace
      };
      axios
        .post(`${self.url}AppLog/GetAppLogByFilter`, temp)
        .then(function(response) {
          if (response.data.status != 0) {
            self.searchdialog = false;
            self.logdata = response.data.data;
            self.totalCount = response.data.data.length;
            self.searchStatus = true;
            self.clearFileds();
          } else {
            self.searchdialog = false;
            self.clearFileds();
          }
        })
        .catch(function(error) {
          self.dialog = false;
          alert(error);
        });
    },
    clearFileds() {
      let self = this;
      self.logId = null;
      self.date = null;
      self.userName = null;
      self.ipAddress = null;
      self.phoneModel = null;
      self.description = null;
      self.logType = null;
      self.methodName = null;
      self.exception = null;
      self.logTrac = null;
    },
    disableDate(value) {
      let self = this;
      const date = new Date(value);
      const today = new Date();
      /* if (date <= today) {
      } else {
        return date;
      } */
    },

    ConvestDateFormat(value) {
      let output = "-";
      let temp = new Date(value);
      try {
        let day = temp
          .getDate()
          .toString()
          .padStart(2, 0);
        let month = (temp.getMonth() + 1).toString().padStart(2, 0);
        let year = temp.getFullYear();
        output = `${day}/${month}/${year}`;
        return output;
      } catch (err) {
        return output;
      }
    },

    // New
    openModalNew() {
      //if (this.companyID != "" && this.companyID != null) {
      this.GetEmployeeAll();
      this.isModalAddVisible = true;
      //this.$refs.modalNew.$el.style.display = "block";
      // } else {
      //   alert("Select company first!");
      // }
    },
    searchName() {
      return this.$t("searchwith");
    },
    GetAllCompany() {
      let self = this;
      self.dialog = true;
      let temp = {
        from: self.logDateFrom.toLocaleString(),
        to: self.logDateTo
          ? self.logDateTo.toLocaleString()
          : new Date().toLocaleString(),
        status: self.current == "running" ? 1 : 0,
        LogType: self.logtypeDDL.find(f => f.value == self.logtype).text,
        offset: this.getoffset()
      };
      console.log(temp);
      axios
        .post(`${self.url}AppLog/GetAppLog`, temp)
        .then(function(response) {
          self.dialog = false;
          self.logdataTemp = response.data.data;
          self.logdataAll = response.data.data;
          self.logdata = response.data.data;
          self.totalCount = response.data.data.length;
          self.searchStatus = false;
          // self.add_log(
          //   "-", //phonemodal
          //   "Get All Company", //description
          //   "Medium", //logType
          //   "GetAllCompany", //methodName
          //   "", //exception
          //   "", //logTrace
          //   44 //correctionID
          // );
        })
        .catch(function(error) {
          // self.add_log(
          //   "-", //phonemodal
          //   "Get All Company Fail", //description
          //   "Critical", //logType
          //   "GetAllCompany", //methodName
          //   error.message, //exception
          //   JSON.stringify(error), //logTrace
          //   44 //correctionID
          // );
          self.dialog = false;
        });
    }
  }
};
</script>

<style scoped>
.mx-datepicker svg {
  color: green !important;
}
>>> .dp2 .mx-input {
  border-radius: 5px !important;
  height: 40px;
  border-color: #a4afb7 !important;
}
.switch-btn {
  min-width: 100px;
  width: 150px;
}
.btnCancel {
  background: #fff !important;
  color: #4caf50 !important;
  width: 200px;
}
.btnConfirm {
  background: #4caf50 !important;
  color: #fff !important;
  width: 200px;
}
.labeltext {
  color: #43425d;
  font-size: 14px;
}
.a {
  fill: #43425d;
}
.editButton :hover {
  fill: #4b9160;
}
.mdi-close:hover {
  color: red !important;
}
.searchText {
  height: 40px !important;
  width: 150px;
  font-size: 14px;
  text-transform: capitalize;
}
.jv-breadcrumb {
  background-color: #13322c;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  border-radius: 0;
  border: none;
}
.jv-breadcrumb p {
  padding: 15px 10px;
}

.jv-content {
  margin: 0.5rem 1rem !important;
  /* padding: 3rem; */
  background-color: rgba(255, 255, 255, 1);
  border: none;
}
@media only screen and (max-width: 600px) {
  .jv-content {
    margin: 1.5rem 0 !important;
  }
}

.btn-new {
  border-color: #13322c;
}
.jv-sub {
  display: inline;
  padding-left: 20px;
  color: rgba(47, 154, 97, 1);
  font-weight: bold;
}

.jv-announcements {
  margin: 10px 15px 0;
  padding: 15px 0px 10px;
  border-bottom: 1px solid rgba(233, 233, 240, 1);
}
.jv-announcements p {
  font-size: 14px;
  color: rgba(67, 66, 93, 1);
}
.jv-announcements p:first-child {
  font-size: 18px;
  font-weight: bold;
}
.jv-announcements p:last-child {
  font-size: 14px;
  color: rgba(47, 154, 97, 1);
}

.jv-announcements .jv-btn-edit {
  display: inline-block;
  width: 50%;
  font-size: 22px;
  color: rgba(77, 79, 92, 1);
}
.jv-announcements .jv-btn-edit :hover {
  color: rgba(47, 154, 97, 1);
}
.jv-announcements .jv-btn-del {
  display: inline-block;
  width: 50%;
  font-size: 26px;
  color: rgba(77, 79, 92, 1);
}
.jv-announcements .jv-btn-del:hover {
  color: rgba(229, 76, 71, 1);
}

.btn-group {
  margin: 0 auto;
  padding-top: 25px;
  width: auto;
}
.btn-group button {
  margin: 0 10px;
  border-color: rgba(232, 233, 236, 1);
  color: rgba(77, 79, 92, 1);
  border-radius: 3px !important;
}
.btn-group button.active {
  background-color: #13322c !important;
  border-color: #13322c !important;
}
.CalendarSearch {
  width: 100%;
  height: 40px;
}
</style>

<style>
.confirm.v-card.v-sheet.theme--light {
  padding: 35px 18px 20px 35px;
}
.dp2 .mx-input {
  border-radius: 5px !important;
  height: 40px;
}
.export-dialog.v-dialog.v-dialog--active {
  height: 486px;
  background: #999999;
  padding-top: 85px;
  box-shadow: none;
  overflow: unset;
  background: transparent;
}
.logsTable .v-data-table__wrapper {
  height: 600px;
  overflow-x: auto;
  overflow-y: auto !important;
}
.mx-datepicker svg {
  color: gray !important;
}

.CalendarSearch .mx-input {
  height: 40px;
}

.searchfield.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid rgb(204, 205, 209);
  box-shadow: none;
  width: 100% !important;
}
.mdi-window-close:hover {
  color: red !important;
}
.v-data-table-header {
  font: 15px "Source Sans Pro", sans-serif;
  letter-spacing: 0;
  background-color: #dbdbda;
}
.searchicon {
  background-color: #6cc8a0;
  padding-top: 3px;
  margin-right: -12px;
  margin-top: -8px;
  margin-bottom: -6px;
  height: 40px;
  width: 40px;
}
/* .v-pagination__item {
  color: #4d4f5c !important;
  opacity: 0.5 !important;
} */

@media only screen and (max-width: 768px) {
  .card-mobile {
    margin-left: 1rem !important;
  }
}

@media only screen and (max-width: 414px) {
  .title-text-mobile {
    margin-left: 12%;
  }
}

@media only screen and (max-width: 375px) {
  .title-div-mobile {
    padding: 10px;
  }

  .title-text-mobile {
    width: 250px !important;
    margin-left: 12%;
  }
}

@media only screen and (max-width: 320px) {
  .title-div-mobile {
    padding: 10px;
  }

  .title-text-mobile {
    width: 200px !important;
    margin-left: 12%;
  }
}
</style>
